import React from 'react';

const noopErrorLogger = {
  notify() {},

  leaveBreadcrumb() {}

};
const ErrorLoggerContext = /*#__PURE__*/React.createContext(noopErrorLogger);

export { ErrorLoggerContext, noopErrorLogger };
